import { Switch as AntSwitch, SwitchProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledSwitch = styled(AntSwitch)`
  height: 16px;
  width: 32px;
  min-width: 32px;

  .ant-switch-handle {
    height: 12px;
    width: 12px;
    left: 3px;
  }

  &.ant-switch-checked {
    background: #0071cd;

    .ant-switch-handle {
      left: calc(100% - 12px - 3px);
    }
  }

  &:focus,
  &.ant-switch-checked:focus {
    box-shadow: 0 0 0 1px #fff;
  }
`;

export const Switch = React.forwardRef<
  React.RefAttributes<HTMLElement>,
  SwitchProps & React.RefAttributes<HTMLElement>
>((props) => {
  return <StyledSwitch className="bg-sy-neutral-40" {...props} />;
});
